/**
 * State for search
 */
export const state = {
  /**
   * The search term that is currently being searched for
   */
  searchValue: "",
  /**
   * The search filter only used in portal email (filtering subject + sender + recipients)
   */
  filtertypeAll: true,

  /**
   * To filter only subject - used only on portal email module.
   */
  filtertypeSubject: false,

  /**
   * To filter only senders - used only on portal email module.
   */
  filtertypeSender: false,

  /**
   * To filter only recipients - used on portal emaim module.
   */
  filtertypeReceiver: false,
  /**
   * Start date for the appointment search - Must be a valid date
   */
  startDate: {
    /**
     * Day of the month
     * 1 - 31
     */
    dayOfMonth: 0,
    /**
     * Month
     * 1 - 12
     */
    month: 0,
    /**
     * Year
     */
    year: 0
  },
  /**
   * End date for the appointment search - Must be a valid date
   */
  endDate: {
    /**
     * Day of the month
     * 1 - 31
     */
    dayOfMonth: 0,
    /**
     * Month
     * 1 - 12
     */
    month: 0,
    /**
     * Year
     */
    year: 0
  },
  /**
   * The search results
   * Format [type.id]: {
   * app_date: "2020-06-18" - The application date
   * app_end_hh: 1 - The end time hour
   * app_end_mm: 31 - The end time minute
   * app_end_tt: 0 - End AM(0) or PM(1)
   * app_start_hh: 0 - The start time hour
   * app_start_mm: 46 - The start time minute
   * app_start_tt: 0 - Start AM(0) or PM(1)
   * app_type: 0 - appointment type (client or other)
   * client_id: 2412 - The client id if any
   * client_type: 0 - The client type if any
   * firstName: "23sad" - The first name if any
   * id: 388191 - The id of the appointment
   * is_cancelled: 0 - If the appointment is cancelled
   * lastName: "15 oct" - The last name if any
   * middleName: "" - The middle name if any
   * namePrefix: "" - Name prefix if any
   * nameSuffix: "" - Name suffix if any
   * otherevent_id: 0 - Other event id if any
   * otherevent_name: null - Other event name if any
   * otherevent_type: 0 - Other event type if any
   * provider_id: 2213 - Provider id
   * }[]
   */
  results: {},

  emailResults: {},
  /**
   * Weather search is going on - To show search loader
   */
  searchingLoader: false,
  /**
   * Weather the search result is to be removed or not.
   * Search result is not supposed to be removed when back button is hit without doing any action with the result
   */
  removeResults: true,
  /**
   * Weacher to show the search result on page load
   */
  showResultsNow: false
};
